import Label from 'ui/label';

export default class ScoreLabel extends Label {
  constructor(x,y, colour) {
    super(x,y,'scoreLabel');

    this.element.className += ' label'; // TODO
    this.element.style.backgroundColor = colour;
  }
}



// WEBPACK FOOTER //
// ./src/ui/scoreLabel.js